var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "h-100" },
    [
      _c(
        "div",
        [
          _c(
            "b-form",
            {
              ref: "form",
              staticClass: "repeater-form",
              style: { height: _vm.trHeight },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.addItem($event)
                },
                change: function ($event) {
                  return _vm.formChanged()
                },
              },
            },
            _vm._l(_vm.items, function (item, mainStepIndex) {
              return _c(
                "b-container",
                {
                  key: item.serial,
                  ref: "row",
                  refInFor: true,
                  staticClass: "pb-2",
                  attrs: { id: item.serial },
                },
                [
                  _c("div", { staticClass: "d-flex border mb-1" }, [
                    _c(
                      "div",
                      { staticClass: "flex-grow-1 p-1" },
                      [
                        _c(
                          "b-row",
                          [
                            _c("b-col", { attrs: { md: "12" } }, [
                              _c("h3", [
                                _vm._v(
                                  "Operation Step #" + _vm._s(mainStepIndex + 1)
                                ),
                              ]),
                            ]),
                            _c(
                              "b-col",
                              { attrs: { md: "3" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Operation Step",
                                      "label-for": "Operation-name",
                                    },
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "Operation-name",
                                        type: "text",
                                        placeholder: "Ex : Cutting",
                                      },
                                      model: {
                                        value: item.name,
                                        callback: function ($$v) {
                                          _vm.$set(item, "name", $$v)
                                        },
                                        expression: "item.name",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { lg: "3", md: "1" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Work Station",
                                      "label-for": "WorkStation",
                                    },
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "WorkStation",
                                        placeholder: "WorkStation",
                                      },
                                      model: {
                                        value: item.workstation,
                                        callback: function ($$v) {
                                          _vm.$set(item, "workstation", $$v)
                                        },
                                        expression: "item.workstation",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "3" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Time Taken",
                                      "label-for": "cycleHours",
                                    },
                                  },
                                  [
                                    _c("b-form-input", {
                                      attrs: {
                                        id: "cycleHours",
                                        type: "number",
                                        placeholder: "1 hour",
                                        min: "1",
                                        max: "100",
                                        disabled:
                                          item.substeps &&
                                          item.substeps.length > 0,
                                      },
                                      model: {
                                        value: item.cycleHours,
                                        callback: function ($$v) {
                                          _vm.$set(item, "cycleHours", $$v)
                                        },
                                        expression: "item.cycleHours",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "3" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Equipment",
                                      "label-for": "Equipments",
                                    },
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        options: _vm.formattedEquipment,
                                        reduce: function (equipment) {
                                          return equipment.id
                                        },
                                        label: "name",
                                        multiple: "",
                                      },
                                      model: {
                                        value: item.equipments,
                                        callback: function ($$v) {
                                          _vm.$set(item, "equipments", $$v)
                                        },
                                        expression: "item.equipments",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "6" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Assign Staff",
                                      "label-for": "staffId",
                                    },
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        options: _vm.formattedUsers,
                                        reduce: function (user) {
                                          return user.id
                                        },
                                        label: "name",
                                        multiple: "",
                                        clearable: false,
                                      },
                                      model: {
                                        value: item.users,
                                        callback: function ($$v) {
                                          _vm.$set(item, "users", $$v)
                                        },
                                        expression: "item.users",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "3" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Start Date",
                                      "label-for": "startDate",
                                    },
                                  },
                                  [
                                    _c("b-form-datepicker", {
                                      staticClass: "mb-1",
                                      attrs: {
                                        min: _vm.minDate,
                                        max: item.endDate,
                                      },
                                      model: {
                                        value: item.startDate,
                                        callback: function ($$v) {
                                          _vm.$set(item, "startDate", $$v)
                                        },
                                        expression: "item.startDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "3" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "End Date",
                                      "label-for": "endDate",
                                    },
                                  },
                                  [
                                    _c("b-form-datepicker", {
                                      staticClass: "mb-1",
                                      attrs: { min: item.startDate },
                                      model: {
                                        value: item.endDate,
                                        callback: function ($$v) {
                                          _vm.$set(item, "endDate", $$v)
                                        },
                                        expression: "item.endDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        item.substeps && item.substeps.length > 0
                          ? _c(
                              "div",
                              { staticClass: "my-1" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleSubStep(mainStepIndex)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.openSubSteps[mainStepIndex]
                                            ? "Hide"
                                            : "Show"
                                        ) +
                                        " Sub Operation Steps "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.openSubSteps[mainStepIndex]
                          ? _c(
                              "div",
                              _vm._l(
                                item.substeps,
                                function (substep, substepIndex) {
                                  return _c(
                                    "b-card",
                                    {
                                      key: substepIndex,
                                      staticClass: "border shadow-none",
                                      attrs: { "no-body": "" },
                                    },
                                    [
                                      _c(
                                        "b-card-body",
                                        { staticClass: "d-flex p-0" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "flex-grow-1 p-1" },
                                            [
                                              _c(
                                                "b-row",
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { md: "12" } },
                                                    [
                                                      _c("h3", [
                                                        _vm._v(
                                                          "Sub Operation Step #" +
                                                            _vm._s(
                                                              substepIndex + 1
                                                            )
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            label:
                                                              "Sub Operation Step Name",
                                                            "label-for":
                                                              "subOpStepName",
                                                          },
                                                        },
                                                        [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              id: "subOpStepName",
                                                              type: "text",
                                                              placeholder:
                                                                "Ex : Cutting",
                                                            },
                                                            model: {
                                                              value:
                                                                substep.name,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    substep,
                                                                    "name",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "substep.name",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            label:
                                                              "Work Station",
                                                            "label-for":
                                                              "WorkStationSubOp",
                                                          },
                                                        },
                                                        [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              id: "WorkStationSubOp",
                                                              placeholder:
                                                                "WorkStation",
                                                            },
                                                            model: {
                                                              value:
                                                                substep.workstation,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    substep,
                                                                    "workstation",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "substep.workstation",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            label:
                                                              "Number of Cycles",
                                                            "label-for":
                                                              "cyclesSupOp",
                                                          },
                                                        },
                                                        [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              id: "cyclesSupOp",
                                                              type: "number",
                                                              placeholder:
                                                                "1 cycle",
                                                              min: "1",
                                                              max: "100",
                                                            },
                                                            model: {
                                                              value:
                                                                substep.cycles,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    substep,
                                                                    "cycles",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "substep.cycles",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            label: "Cycle Time",
                                                            "label-for":
                                                              "cycleHoursSubOp",
                                                          },
                                                        },
                                                        [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              id: "cycleHoursSubOp",
                                                              type: "number",
                                                              placeholder:
                                                                "1 hour",
                                                              min: "1",
                                                              max: "100",
                                                            },
                                                            model: {
                                                              value:
                                                                substep.cycleHours,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    substep,
                                                                    "cycleHours",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "substep.cycleHours",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            label: "Labour",
                                                            "label-for":
                                                              "labourId",
                                                          },
                                                        },
                                                        [
                                                          _c("b-form-select", {
                                                            attrs: {
                                                              id: "labourId",
                                                              options:
                                                                _vm.labours,
                                                              "value-field":
                                                                "id",
                                                              "text-field":
                                                                "labourName",
                                                            },
                                                            model: {
                                                              value:
                                                                substep.labourId,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    substep,
                                                                    "labourId",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "substep.labourId",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            label:
                                                              "Labour Cost",
                                                            "label-for":
                                                              "labourCost",
                                                          },
                                                        },
                                                        [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              id: "labourCost",
                                                              type: "number",
                                                              placeholder:
                                                                "Rs 10",
                                                              readonly: "",
                                                            },
                                                            model: {
                                                              value:
                                                                substep.labourCost,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    substep,
                                                                    "labourCost",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "substep.labourCost",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            label: "Labour Qty",
                                                            "label-for":
                                                              "labourQty",
                                                            placeholder:
                                                              "Labour Quantity",
                                                          },
                                                        },
                                                        [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              id: "labourQty",
                                                              type: "number",
                                                            },
                                                            model: {
                                                              value:
                                                                substep.labourQty,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    substep,
                                                                    "labourQty",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "substep.labourQty",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "b-col",
                                                    { attrs: { md: "3" } },
                                                    [
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            label:
                                                              "Total Labour Cost",
                                                            "label-for":
                                                              "totalLabourCost",
                                                          },
                                                        },
                                                        [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              id: "totalLabourCost",
                                                              type: "number",
                                                              readonly: "",
                                                            },
                                                            model: {
                                                              value:
                                                                substep.totalLabourCost,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    substep,
                                                                    "totalLabourCost",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "substep.totalLabourCost",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "b-row",
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { md: "12" } },
                                                    [
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            label:
                                                              "Assign Staff",
                                                            "label-for":
                                                              "staffId",
                                                          },
                                                        },
                                                        [
                                                          _c("v-select", {
                                                            attrs: {
                                                              options:
                                                                _vm.formattedUsers,
                                                              reduce: function (
                                                                user
                                                              ) {
                                                                return user.id
                                                              },
                                                              label: "name",
                                                              multiple: "",
                                                              clearable: false,
                                                            },
                                                            model: {
                                                              value:
                                                                substep.users,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    substep,
                                                                    "users",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "substep.users",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._l(
                                                substep.equipments,
                                                function (
                                                  equipment,
                                                  equipmentIndex
                                                ) {
                                                  return _c(
                                                    "b-row",
                                                    { key: equipmentIndex },
                                                    [
                                                      _c(
                                                        "b-col",
                                                        { attrs: { md: "3" } },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                label:
                                                                  "Equipment",
                                                                "label-for":
                                                                  "equipmentId",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-select",
                                                                {
                                                                  attrs: {
                                                                    id: "equipmentId",
                                                                    options:
                                                                      _vm.equipments,
                                                                    "value-field":
                                                                      "id",
                                                                    "text-field":
                                                                      "name",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      equipment.equipmentId,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          equipment,
                                                                          "equipmentId",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "equipment.equipmentId",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "b-col",
                                                        { attrs: { md: "3" } },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                label:
                                                                  "Equipment Cost",
                                                                "label-for":
                                                                  "equipmentCost",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  attrs: {
                                                                    id: "equipmentCost",
                                                                    type: "number",
                                                                    placeholder:
                                                                      "Equipment Cost",
                                                                    readonly:
                                                                      "",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      equipment.equipmentCost,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          equipment,
                                                                          "equipmentCost",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "equipment.equipmentCost",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "b-col",
                                                        { attrs: { md: "2" } },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                label:
                                                                  "Equipment Qty",
                                                                "label-for":
                                                                  "equipmentQty",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  attrs: {
                                                                    id: "equipmentQty",
                                                                    type: "number",
                                                                    placeholder:
                                                                      "Equipment Qty",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      equipment.equipmentQty,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          equipment,
                                                                          "equipmentQty",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "equipment.equipmentQty",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "b-col",
                                                        { attrs: { md: "3" } },
                                                        [
                                                          _c(
                                                            "b-form-group",
                                                            {
                                                              attrs: {
                                                                label:
                                                                  "Total Equipment Cost",
                                                                "label-for":
                                                                  "totalEquipmentCost",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "b-form-input",
                                                                {
                                                                  attrs: {
                                                                    id: "totalEquipmentCost",
                                                                    type: "number",
                                                                    readonly:
                                                                      "",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      equipment.totalEquipmentCost,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          equipment,
                                                                          "totalEquipmentCost",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "equipment.totalEquipmentCost",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "b-col",
                                                        {
                                                          staticClass:
                                                            "d-flex flex-shrink-1 align-items-center",
                                                          attrs: { md: "1" },
                                                        },
                                                        [
                                                          _c("feather-icon", {
                                                            staticClass:
                                                              "cursor-pointer",
                                                            attrs: {
                                                              size: "16",
                                                              icon: "XIcon",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.removeEquipment(
                                                                  mainStepIndex,
                                                                  substepIndex,
                                                                  equipmentIndex
                                                                )
                                                              },
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              _c(
                                                "b-row",
                                                [
                                                  _c(
                                                    "b-col",
                                                    { attrs: { md: "4" } },
                                                    [
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            label:
                                                              "Direct Cost",
                                                            "label-for":
                                                              "directCostSubOp",
                                                          },
                                                        },
                                                        [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              id: "directCostSubOp",
                                                              type: "number",
                                                              placeholder:
                                                                "Rs 10",
                                                              readonly: "",
                                                            },
                                                            model: {
                                                              value:
                                                                substep.directCost,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    substep,
                                                                    "directCost",
                                                                    _vm._n($$v)
                                                                  )
                                                                },
                                                              expression:
                                                                "substep.directCost",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "b-col",
                                                    { attrs: { md: "4" } },
                                                    [
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            label:
                                                              "Indirect Cost",
                                                            "label-for":
                                                              "indirectCostSubOp",
                                                          },
                                                        },
                                                        [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              id: "indirectCostSubOp",
                                                              type: "number",
                                                              placeholder:
                                                                "Rs 10",
                                                            },
                                                            model: {
                                                              value:
                                                                substep.indirectCost,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    substep,
                                                                    "indirectCost",
                                                                    _vm._n($$v)
                                                                  )
                                                                },
                                                              expression:
                                                                "substep.indirectCost",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "b-col",
                                                    { attrs: { md: "4" } },
                                                    [
                                                      _c(
                                                        "b-form-group",
                                                        {
                                                          attrs: {
                                                            label:
                                                              "Total Cost (Rs)",
                                                            "label-for":
                                                              "totalCostSubOp",
                                                          },
                                                        },
                                                        [
                                                          _c("b-form-input", {
                                                            attrs: {
                                                              id: "totalCostSubOp",
                                                              type: "number",
                                                              placeholder:
                                                                "Rs 10",
                                                            },
                                                            model: {
                                                              value:
                                                                substep.totalCost,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    substep,
                                                                    "totalCost",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "substep.totalCost",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            2
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex flex-column justify-content-between border-left ml-1 px-25 py-50",
                                            },
                                            [
                                              _c("feather-icon", {
                                                staticClass: "cursor-pointer",
                                                attrs: {
                                                  size: "16",
                                                  icon: "XIcon",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.removeSubStep(
                                                      mainStepIndex,
                                                      substepIndex
                                                    )
                                                  },
                                                },
                                              }),
                                              _c(
                                                "b-dropdown",
                                                {
                                                  attrs: {
                                                    variant: "link",
                                                    "no-caret": "",
                                                    "toggle-class": "p-0 ",
                                                    right: "",
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "button-content",
                                                        fn: function () {
                                                          return [
                                                            _c("feather-icon", {
                                                              staticClass:
                                                                "align-middle text-body",
                                                              attrs: {
                                                                icon: "MoreVerticalIcon",
                                                                size: "16",
                                                              },
                                                            }),
                                                          ]
                                                        },
                                                        proxy: true,
                                                      },
                                                    ],
                                                    null,
                                                    true
                                                  ),
                                                },
                                                [
                                                  _c(
                                                    "b-dropdown-item",
                                                    {
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.addEquipment(
                                                            mainStepIndex,
                                                            substepIndex
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v(" Add Equipment ")]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }
                              ),
                              1
                            )
                          : _vm._e(),
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "2" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Status",
                                      "label-for": "status",
                                    },
                                  },
                                  [
                                    _c("b-form-select", {
                                      attrs: {
                                        options: _vm.OperationsStatusOptions,
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.callChangeStatus()
                                        },
                                      },
                                      model: {
                                        value: item.status,
                                        callback: function ($$v) {
                                          _vm.$set(item, "status", $$v)
                                        },
                                        expression: "item.status",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "4" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Comment",
                                      "label-for": "comment",
                                    },
                                  },
                                  [
                                    _c("b-form-textarea", {
                                      attrs: {
                                        id: "textarea-default",
                                        placeholder: "Comment",
                                        rows: "2",
                                        "no-resize": "",
                                      },
                                      model: {
                                        value: item.comment,
                                        callback: function ($$v) {
                                          _vm.$set(item, "comment", $$v)
                                        },
                                        expression: "item.comment",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-column justify-content-between border-left ml-1 px-25 py-50 h-100",
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "cursor-pointer",
                            attrs: { size: "16", icon: "XIcon" },
                            on: {
                              click: function ($event) {
                                return _vm.removeItem(mainStepIndex)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ]
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "b-button",
        {
          directives: [
            {
              name: "ripple",
              rawName: "v-ripple.400",
              value: "rgba(255, 255, 255, 0.15)",
              expression: "'rgba(255, 255, 255, 0.15)'",
              modifiers: { 400: true },
            },
          ],
          attrs: { variant: "primary" },
          on: { click: _vm.addItem },
        },
        [
          _c("feather-icon", {
            staticClass: "mr-25",
            attrs: { icon: "PlusIcon" },
          }),
          _c("span", [_vm._v("Add Operation Steps")]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }